export default {
  namespaced: true,
  state: {
    record: {},
  },
  mutations: {
    ADD(state, payload) {
      state.record[payload.key] = payload.data;
    },
  },
  getters: {
    record(state) {
      return (key) => {
        return state.record[key];
      };
    },
  },
};
